import { render, staticRenderFns } from "./AssessmentPrinter.vue?vue&type=template&id=75c20789"
import script from "./AssessmentPrinter.vue?vue&type=script&lang=js"
export * from "./AssessmentPrinter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports